import 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import _Hidden from 'reakit/Hidden';

var HiddenHide = styled(_Hidden.Hide).withConfig({
  displayName: "styled__HiddenHide",
  componentId: "sc-1iaaa8w-0"
})(["", ";"], theme('fannypack.Hidden.Hide.base'));
var HiddenShow = styled(_Hidden.Show).withConfig({
  displayName: "styled__HiddenShow",
  componentId: "sc-1iaaa8w-1"
})(["", ";"], theme('fannypack.Hidden.Show.base'));
var HiddenToggle = styled(_Hidden.Toggle).withConfig({
  displayName: "styled__HiddenToggle",
  componentId: "sc-1iaaa8w-2"
})(["", ";"], theme('fannypack.Hidden.Toggle.base'));
var Hidden = styled(_Hidden).withConfig({
  displayName: "styled__Hidden",
  componentId: "sc-1iaaa8w-3"
})(["&{", ";}"], theme('fannypack.Hidden.base'));

export default Hidden;
export { Hidden, HiddenHide, HiddenShow, HiddenToggle };
